if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // v3 (2026-06-01) : ADD → ADDING → ADDED ✓ feedback, locale-aware
        try {
          var locale = (document.documentElement.getAttribute('lang') || 'en').toLowerCase();
          var L = locale.indexOf('de') === 0 ? 'de'
                : locale.indexOf('fr') === 0 ? 'fr'
                : locale.indexOf('es') === 0 ? 'es' : 'en';
          var I = {
            en: { adding: 'Adding', added: 'Added' },
            de: { adding: 'Wird hinzugefügt', added: 'Hinzugefügt' },
            fr: { adding: 'En cours', added: 'Ajouté' },
            es: { adding: 'Añadiendo', added: 'Añadido' }
          };
          this._luvI18N = I[L];
        } catch (e) {
          this._luvI18N = { adding: 'Adding', added: 'Added' };
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        // v3 : strong double-click guard via aria-disabled + dataset state
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (this.submitButton.dataset.luvState === 'adding' || this.submitButton.dataset.luvState === 'added') return;

        this.handleErrorMessage();

        // v3 : capture original label so we can restore later
        try {
          if (this.submitButtonText && !this.submitButton.dataset.luvOriginal) {
            this.submitButton.dataset.luvOriginal = this.submitButtonText.textContent.trim();
          }
        } catch (e) {}

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.submitButton.dataset.luvState = 'adding';
        // v3 : show "Adding…" text — replaces uncertainty (no persistent spinner)
        try {
          if (this.submitButtonText) {
            this.submitButtonText.textContent = (this._luvI18N && this._luvI18N.adding) || 'Adding';
          }
        } catch (e) {}
        // Spinner stays hidden in v3 to avoid the "persistent spinner" uncertainty pattern called out in the brief.
        // The text label itself signals progress (ADDING → ADDED ✓).
        var spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.add('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        var self = this;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }

            // v3 : ADDED ✓ state + open drawer immediately (CRO brief section 2)
            try {
              if (this.submitButtonText) {
                var addedLabel = (this._luvI18N && this._luvI18N.added) || 'Added';
                this.submitButtonText.textContent = addedLabel + ' ✓';
              }
              this.submitButton.dataset.luvState = 'added';
            } catch (e) {}

            // Open the cart drawer immediately so the customer SEES the cart update
            try {
              var drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.open === 'function' && !drawer.classList.contains('active')) {
                drawer.open(this.submitButton);
              } else if (drawer && typeof drawer.classList !== 'undefined' && !drawer.classList.contains('active')) {
                // fallback for themes where open() isn't defined on the element
                drawer.classList.add('active');
                document.body.classList.add('overflow-hidden');
              }
            } catch (e) {}

            // Dispatch cart:updated so luv-rewards.js + xsell re-render
            try {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: response }));
            } catch (e) {}

            // Restore button to original ADD label after 1100ms
            setTimeout(function () {
              try {
                if (!self.submitButton) return;
                if (self.submitButtonText) {
                  var orig = self.submitButton.dataset.luvOriginal || (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
                  self.submitButtonText.textContent = orig;
                }
                self.submitButton.classList.remove('loading');
                self.submitButton.removeAttribute('aria-disabled');
                self.submitButton.dataset.luvState = '';
              } catch (e) {}
            }, 1100);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            // Spinner cleanup (we keep it hidden, but be defensive)
            const sp = this.querySelector('.loading__spinner');
            if (sp) sp.classList.add('hidden');
            // Note: button label restoration is handled by setTimeout above to allow the ADDED ✓ frame to be visible.
            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
